module.exports = __webpack_public_path__ + "static/Flavor_18AMT90218-5d3ca0f1c2129fde81dbf3902b587303.pdf";